import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';

import CommonTooltip from '../../../components/common-tooltip/CommonTooltip';
import Icon from '../../../icons/Icon';

import scss from './AiGeneratedChip.module.scss';

function AiGeneratedChip({ size = 'md' }) {
  const { t } = useTranslation('activ8');
  const label = t('aiGenerated');
  const isIconOnly = size === 'sm';

  const icon = <Icon icon={AutoAwesomeOutlinedIcon} className={scss.icon} disableCommonColors />;

  if (isIconOnly) {
    return (
      <div className={scss.wrapper}>
        <CommonTooltip title={label}>
          <span className={clsx(scss.chip, scss.sm)}>{icon}</span>
        </CommonTooltip>
      </div>
    );
  }

  return (
    <div className={scss.wrapper}>
      <span className={clsx(scss.chip, scss.md)}>
        {icon}
        <span className={scss.label}>{label}</span>
      </span>
    </div>
  );
}

export default AiGeneratedChip;
